import React from "react";
import { Controller } from "react-hook-form";
import {
  Grid,
  Box,
  Typography,
  Button,
} from "@mui/material";

import SwitchInput from "../../../components/SwitchInput";
import { BOOKING_TYPES } from "./constants";

const TableBookingToggle = ({ 
  control,
  watch,
  onNavigateToSettings,
  isLoading = false,
  styles
}) => {
  const watchIsEnabled = watch("isEnabled");

  return (
    <Grid container spacing={3}>
      {/* Enable/Disable Table Booking */}
      <Grid item xs={12} md={6}>
        <Box 
          className={styles.settingRow} 
          sx={{ 
            display: 'flex !important', 
            alignItems: 'center !important', 
            justifyContent: 'space-between !important',
            minHeight: '64px',
          }}
        >
          <Typography className={styles.textInputLabel}>
            Enable Table Booking
          </Typography>
          <Controller
            name="isEnabled"
            control={control}
            render={({ field }) => (
              <SwitchInput
                checked={field.value}
                onChange={field.onChange}
                disabled={isLoading}
              />
            )}
          />
        </Box>
      </Grid>

      {/* Table Booking Type Toggle */}
      {watchIsEnabled && (
        <Grid item xs={12} md={6}>
          <Box 
            className={styles.settingRow} 
            sx={{ 
              display: 'flex !important', 
              alignItems: 'center !important', 
              justifyContent: 'space-between !important',
              minHeight: '48px',
              padding: '12px 0 !important'
            }}
          >
            <Typography className={styles.textInputLabel}>
              Booking Type
            </Typography>
            <Controller
              name="type"
              control={control}
              render={({ field }) => (
                <Box 
                  className={styles.typeToggle}
                  sx={{
                    display: 'flex',
                    border: '1px solid #AAA',
                    borderRadius: '6px',
                    overflow: 'hidden',
                    backgroundColor: '#ffffff',
                  }}
                >
                  <Box
                    className={`${styles.typeOption} ${
                      field.value === BOOKING_TYPES.CLASSIC ? styles.typeOptionActive : ""
                    }`}
                    data-type={BOOKING_TYPES.CLASSIC}
                    onClick={() => !isLoading && field.onChange(BOOKING_TYPES.CLASSIC)}
                    sx={{
                      padding: '8px 16px',
                      cursor: isLoading ? "not-allowed" : "pointer",
                      backgroundColor: field.value === BOOKING_TYPES.CLASSIC ? '#000000' : '#ffffff',
                      color: field.value === BOOKING_TYPES.CLASSIC ? '#ffffff' : '#000000',
                      fontSize: '14px',
                      fontFamily: 'GilroySemiBold',
                      transition: 'all 0.2s ease',
                      borderRight: '1px solid #AAA',
                      opacity: isLoading ? 0.6 : 1,
                      '&:hover': {
                        backgroundColor: field.value === BOOKING_TYPES.CLASSIC ? '#000000' : '#f5f5f5',
                      }
                    }}
                  >
                    Classic
                  </Box>
                  <Box
                    className={`${styles.typeOption} ${
                      field.value === BOOKING_TYPES.SUPREME ? styles.typeOptionActive : ""
                    }`}
                    data-type={BOOKING_TYPES.SUPREME}
                    onClick={() => !isLoading && field.onChange(BOOKING_TYPES.SUPREME)}
                    sx={{
                      padding: '8px 16px',
                      cursor: isLoading ? "not-allowed" : "pointer",
                      backgroundColor: field.value === BOOKING_TYPES.SUPREME ? '#000000' : '#ffffff',
                      color: field.value === BOOKING_TYPES.SUPREME ? '#ffffff' : '#000000',
                      fontSize: '14px',
                      fontFamily: 'GilroySemiBold',
                      transition: 'all 0.2s ease',
                      opacity: isLoading ? 0.6 : 1,
                      '&:hover': {
                        backgroundColor: field.value === BOOKING_TYPES.SUPREME ? '#000000' : '#f5f5f5',
                      }
                    }}
                  >
                    Supreme
                  </Box>
                </Box>
              )}
            />
          </Box>
        </Grid>
      )}

      {/* Navigate to detailed settings when enabled */}
      {watchIsEnabled && onNavigateToSettings && (
        <Grid item xs={12}>
          <Box className={styles.settingRow}>
            <Typography className={styles.textInputLabel}>
              Configure detailed restaurant booking settings
            </Typography>
            <Button
              variant="outlined"
              onClick={onNavigateToSettings}
              className={styles.configureBtn}
              disabled={isLoading}
            >
              Configure Restaurant Settings
            </Button>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default TableBookingToggle;
